import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { Customer } from "../../models/Customers";
import { DispatchSelector, StateSelector } from "../../modules/selectors";
/**
 * Customer form
 */

export class CustomerForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.modelClass = Customer;
    this.fields = [{
      label: 'Имя',
      name: 'firstName',
      required: true,
      trim: true
    }, {
      label: 'Фамилия',
      name: 'lastName',
      required: true,
      trim: true
    }, {
      label: 'Отчество',
      name: 'middleName',
      required: false,
      trim: true
    }, {
      label: 'Статус',
      name: 'status',
      type: BaseForm.TYPES.DROPDOWN,
      required: true,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(Customer.statuses)
        }
      }
    }, {
      label: 'Роль',
      name: 'role',
      type: BaseForm.TYPES.DROPDOWN,
      required: true,
      fieldKeep: false,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(Customer.roles)
        }
      }
    }, {
      label: 'Пол',
      name: 'gender',
      type: BaseForm.TYPES.DROPDOWN,
      required: true,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(Customer.gender)
        }
      }
    }, {
      label: 'День рождения',
      name: 'birthDay',
      type: BaseForm.TYPES.DATE
    }, {
      label: 'Пароль',
      name: 'password'
    }];
    this.dispatchCreateForm = DispatchSelector.customers.create;
    this.dispatchUpdateForm = DispatchSelector.customers.update;
    this.responseCreateState = StateSelector.customers.create;
    this.responseUpdateState = StateSelector.customers.update;
  }

}